import createCrudModule from 'vuex-crud';
import {client, parseResponse} from '@/api'

export default createCrudModule({
  resource: 'webcams',
  client,
  parseSingle: parseResponse,
  parseList: parseResponse
});
